import { useAllVoices } from '@/hooks/useAllVoices';
import { getLanguageFlagSrc } from '@/utils/getLangaugeFlagSrc';
import { Providers } from '@d-id/types';
import { useMemo } from 'react';
import { IVoiceLanguage } from './useVoicesLanguages';

export interface LanguageValue {
    label: string;
    locale: string;
    flagSrc: string | null;
}

export const useTranslationVoicesLanguages = () => {
    const { data = [], isFetching } = useAllVoices();

    const languagesMap = useMemo(() => {
        const array = data
            .filter(voice => voice.provider === Providers.Elevenlabs && !!voice.language)
            .map(voice => ({
                label: voice.language.split(' (')[0],
                locale: voice.locale,
                flagSrc: getLanguageFlagSrc(voice),
            }))
            .sort((a, b) => a.label.localeCompare(b.label)) as IVoiceLanguage[];

        const map = new Map<string, LanguageValue>();
        array.forEach(voice => map.set(voice.label, voice));
        return map;
    }, [data]);

    return { languagesMap, isFetching };
};
